import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchProjectmelding } from '../services/fetchProjectmelding'

export { useProjectmelding, queryKey }

const queryKey = 'projectmelding'

const useProjectmelding = ({
  id,
  projectdossierId,
}: {
  id?: string
  projectdossierId?: string
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, id, projectdossierId],
    queryFn: () => fetchProjectmelding({ id, projectdossierId }),
    enabled: hasPermissions && (!!id || !!projectdossierId),
    refetchOnMount: true,
  })

  useQueryErrorAlert(
    error,
    errorUpdatedAt,
    'Fout bij ophalen van vooraanmelding',
  )

  return {
    data,
    isLoading,
    isError,
  }
}
